import apiClient from './client'
import type { App, AppWithStats, AppCreate, AppUpdate } from '../types'

export interface AppsListResponse {
  apps: AppWithStats[]
  total: number
}

export interface EnvironmentsResponse {
  environments: string[]
}

export interface ReleasesResponse {
  releases: string[]
}

export interface AppResponse {
  app: App
}

export const appsApi = {
  list: async (skip = 0, limit = 100): Promise<AppsListResponse> => {
    const response = await apiClient.get<AppsListResponse>('/apps', {
      params: { skip, limit },
    })
    return response.data
  },

  get: async (appId: string): Promise<App> => {
    const response = await apiClient.get<App>(`/apps/${appId}`)
    return response.data
  },

  create: async (data: AppCreate): Promise<App> => {
    const response = await apiClient.post<App>('/apps', data)
    return response.data
  },

  update: async (appId: string, data: AppUpdate): Promise<App> => {
    const response = await apiClient.put<App>(`/apps/${appId}`, data)
    return response.data
  },

  delete: async (appId: string): Promise<void> => {
    await apiClient.delete(`/apps/${appId}`)
  },

  getEnvironments: async (): Promise<string[]> => {
    const response = await apiClient.get<EnvironmentsResponse>('/apps/environments')
    return response.data.environments
  },

  getReleases: async (appId: string): Promise<string[]> => {
    const response = await apiClient.get<ReleasesResponse>(`/apps/${appId}/releases`)
    return response.data.releases
  },
}

export type { App, AppWithStats, AppCreate, AppUpdate }
